/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const queryMarket = params => {
  return axios.post(`${base}/query_market`, params)
}
export const getMarketDetail = params => {
  return axios.get(`${base}/market_${params.id}`, params)
}
export const getBasicMarketTable = params => {
  return axios.post(`${base}/basic-info/query_market`, params)
}
export const getBasicMarketDetail = params => {
  return axios.get(`${base}/basic-info/market_${params.id}`)
}
export const getMarketUpload = params => {
  return axios.post(`${base}/query_market_upload`, params)
}
export const batchUploadCreateMarket = params => {
  return axios.post(`${base}/batch_create_market_upload`, params)
}
export const batchUploadUpdateAllRightMarket = params => {
  return axios.post(`${base}/batch_update_market_all_right_upload`, params)
}
export const batchUploadUpdateMarket = params => {
  return axios.post(`${base}/batch_update_market_upload`, params)
}
export const exportMarket = params => {
  return axios.post(`${base}/export_market`, params)
}
export const deleteMarket = params => {
  return axios.post(`${base}/delete_market_${params.id}`, params)
}
export const uploadMarketPhoto = params => {
  return axios.post(`${base}/upload_market_photos`, params)
}
export const updateMarketData = params => {
  return axios.post(`${base}/update_market_${params.id}`, params)
}
export const updateTaskByMarket = params => {
  return axios.post(`${base}/update_task_by_market_${params.id}`, params)
}
export const createMarketData = params => {
  return axios.post(`${base}/create_market`, params)
}
export const queryMarketLog = params => {
  return axios.post(`${base}/query_market_log_${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/market/market.api.js